import { useEffect, useState, useRef } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { Modal, ModalBody, ModalFooter, Button, Input, Form, Select, ToggleSwitch, Tabs, TabContainer } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import { Grid } from '@mui/material';
import { getSystems, getNetworks } from 'Core/data/Helpers';

//Views
import AlertTypesSupported from 'Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/.components/alertTypesSupported';
import EditAlertTypeSupported from 'Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/.components/editAlertTypeSupported';

//Actions 
import {
    clearRedux,
    deviceModelCreateRequest,
    deviceModelUpdateRequest,
    deviceModelGetRequest,
    deviceModelSearchUnitTypes,
    searchEntityRequest,
} from 'Redux/actions';

//Styles
import './index.scss';

const CreateEditDeviceModel = (props) => {
    const { manufacturer, tableRef } = props;
    const { messages } = useIntl();
    const formRef = useRef();
    const dispatch = useDispatch();

    //Redux States
    const { openModal, loading, create, update, current, deviceModel, unitTypes } = useSelector(state => state.createEditDeviceModelRedux);
    const editAlertTypeSupportedOpenModel = useSelector(state => state.editAlertTypeSupportedRedux.openModal)
    const { result } = useSelector(state => state.editAlertTypeSupportedRedux);
    const user = useSelector(state => state.securityRedux.user);
    const alertTypes = useSelector(state => state.generalRedux.alertTypes);

    //Local States
    const [deviceModelTitle, setDeviceModelTitle] = useState("");
    const [tab, setTab] = useState(0);
    //inputs text
    const [name, setName] = useState("");
    const [product, setProduct] = useState("");
    const [markInitialBattery, setMarkInitialBattery] = useState(false);
    const [initialBattery, setInitialBattery] = useState(0);
    const [inputs, setInputs] = useState(0);
    const [outputs, setOutputs] = useState(0);
    //selects
    const [unitTypeId, setUnitTypeId] = useState(null);
    const [system, setSystem] = useState(null);
    const [network, setNetwork] = useState(null);
    //input switches
    const [ota, setOta] = useState(false);
    const [sms, setSms] = useState(false);
    const [starter, setStarter] = useState(false);
    const [driverBehavior, setDriverBehavior] = useState(false);
    const [analytic, setAnalytic] = useState(false);
    const [versionSim, setVersionSim] = useState(false);
    const [motion, setMotion] = useState(false);
    const [obd2alerts, setObd2alerts] = useState(false);
    const [hoursEnable, setHoursEnable] = useState(false);
    const [odometerEnable, setOdometerEnable] = useState(false);
    const [promiles, setPromiles] = useState(false);
    const [comdata, setComdata] = useState(false);
    const [pressurePro, setPressurePro] = useState(false);
    const [vBus, setVBus] = useState(false);
    const [jBus, setJBus] = useState(false);
    const [tow, setTow] = useState(false);
    const [ttu, setTtu] = useState(false);
    const [cariq, setCariq] = useState(false);
    const [carbEnable, setCarbEnable] = useState(false);

    const [supportGeofences, setSupportGeofences] = useState(false);
    const [polygon, setPolygon] = useState(false);
    const [regularShape, setRegularShape] = useState(false);
    const [maxPoints, setMaxPoints] = useState(0);
    const [square, setSquare] = useState(false);
    const [circle, setCircle] = useState(false);
    const [maxGeofences, setMaxGeofences] = useState(0);
    const [currentDM, setCurrentDM] = useState(null);
    const [dmAlertTypes, setDmAlertTypes] = useState([]);

    const closeModal = () => {
        dispatch(clearRedux("CREATE_EDIT_DEVICE_MODEL"));
        setTab(0)
        setName("");
        setProduct("");
        setMarkInitialBattery(false);
        setInitialBattery(0);
        setInputs(0);
        setOutputs(0);

        setUnitTypeId(null);
        setSystem(null);
        setNetwork(null);

        setOta(false);
        setSms(false);
        setStarter(false);
        setDriverBehavior(false);
        setAnalytic(false);
        setVersionSim(false);
        setMotion(false);
        setObd2alerts(false);
        setHoursEnable(false);
        setOdometerEnable(false);
        setPromiles(false);
        setComdata(false);
        setPressurePro(false);
        setVBus(false);
        setJBus(false);
        setTow(false);
        setTtu(false);
        setCariq(false);
        setCarbEnable(false);

        setSupportGeofences(false);
        setMaxGeofences(0);
        setPolygon(false);
        setRegularShape(false);
        setMaxPoints(0);
        setSquare(false);
        setCircle(false);
        setCurrentDM(null);
    }

    const applyChanges = () => {
        let payload = {
            name,
            unitTypeId,
            product,
            maxGeofences,
            system: system.id,
            network: network.id,
            input: inputs,
            output: outputs,
            ota,
            sms,
            starter,
            driverBehavior,
            battery: markInitialBattery,
            initialBattery,
            analytic,
            promiles,
            comData: comdata,
            pressurePro,
            vbus: vBus,
            jbus: jBus,
            obd2Alerts: obd2alerts,
            motion,
            tow,
            ttu,
            cariq,
            hoursEnable,
            odometerEnable,
            carbEnable
        }

        let newAlertTypes = dmAlertTypes.filter(x => !x.id);
        let deleteAlertTypes = dmAlertTypes.filter(x => x.delete);

        let devModelAlertTypes = [...newAlertTypes, ...deleteAlertTypes];
        payload.deviceModelAlertTypes = devModelAlertTypes;

        if (maxGeofences !== 0) {
            let geofenceType = 0;
            if (polygon && (square || circle))
                geofenceType = 2;
            else if (polygon)
                geofenceType = 1;
            else
                geofenceType = 0;

            payload.deviceModelGeofence = {
                geofenceType: geofenceType,
                maxGeofence: maxGeofences,
                polygon,
                maxPoint: maxPoints,
                square,
                circle
            }
        } else if (currentDM?.deviceModelGeofence?.maxGeofence !== 0) {
            // to delete the previous data for geofences
            payload.deviceModelGeofence = {
                geofenceType: 0,
                maxGeofence: 0,
                polygon: 0,
                maxPoint: 0,
                square: 0,
                circle: 0
            }
        }
        if (supportGeofences && !polygon && !circle && !square) {
            //you must select at least a geofence type or both
            NotificationManager.warning(
                messages['create_device_model_geofence_type_missing'],
                messages['create_device_model_create_title'],
                3000
            );
            return;
        }

        if (!current) {
            payload.manufacturerId = manufacturer.id;
            dispatch(deviceModelCreateRequest(payload));
        } else {
            payload.id = current.id;
            dispatch(deviceModelUpdateRequest(payload));
        }
    }

    useEffect(() => {
        if (openModal && current) {
            dispatch(deviceModelGetRequest(current?.id))
        }
        if (openModal) {
            dispatch(deviceModelSearchUnitTypes(manufacturer?.name))
        }
    }, [openModal])

    useEffect(() => {
        if (create?.id) {
            closeModal();
            tableRef && tableRef?.current?.getData();
            dispatch(clearRedux("CREATE_EDIT_DEVICE_MODEL", { create: null }));
            NotificationManager.success(
                messages['create_device_model_create_success_message'],
                messages['create_device_model_create_title'],
                3000
            );
            dispatch(searchEntityRequest({ key: "deviceModels" }))
        }
        if (update?.id) {
            closeModal();
            tableRef && tableRef?.current?.getData();
            dispatch(clearRedux("CREATE_EDIT_DEVICE_MODEL", { update: null }));
            NotificationManager.success(
                messages['create_device_model_update_success_message'],
                messages['create_device_model_edit_title'],
                3000
            );
            dispatch(searchEntityRequest({ key: "deviceModels" }))
        }
        if (deviceModel) {
            setName(deviceModel?.name);
            setProduct(deviceModel?.product);
            setMarkInitialBattery(deviceModel?.initialBattery > 0);
            setInitialBattery(deviceModel?.initialBattery || 0);
            setInputs(deviceModel?.input);
            setOutputs(deviceModel?.output);

            setUnitTypeId(deviceModel?.unitTypeId);
            setSystem(getSystems().find(x => x.id === deviceModel?.system));
            setNetwork(getNetworks().find(x => x.id === deviceModel?.network));

            setOta(deviceModel?.ota);
            setSms(deviceModel?.sms);
            setStarter(deviceModel?.starter);
            setDriverBehavior(deviceModel?.driverBehavior);
            setAnalytic(deviceModel?.analytic);
            setVersionSim(deviceModel?.versionSim);
            setMotion(deviceModel?.motion);
            setObd2alerts(deviceModel?.obd2Alerts);
            setHoursEnable(deviceModel?.hoursEnable);
            setOdometerEnable(deviceModel?.odometerEnable);
            setPromiles(deviceModel?.promiles);
            setComdata(deviceModel?.comData);
            setPressurePro(deviceModel?.pressurePro);
            setVBus(deviceModel?.vbus);
            setJBus(deviceModel?.jbus);
            setTow(deviceModel?.tow);
            setTtu(deviceModel?.ttu);
            setCariq(deviceModel?.cariq);
            setCarbEnable(deviceModel?.carbEnable);

            if (deviceModel?.deviceModelGeofence?.maxGeofence && deviceModel?.deviceModelGeofence?.maxGeofence !== 0) {
                setSupportGeofences(true);
                setPolygon(deviceModel?.deviceModelGeofence?.polygon);
                setRegularShape(deviceModel?.deviceModelGeofence?.circle || deviceModel?.deviceModelGeofence?.square);
                setMaxPoints(deviceModel?.deviceModelGeofence?.maxPoint || 0);
                setSquare(deviceModel?.deviceModelGeofence?.square);
                setCircle(deviceModel?.deviceModelGeofence?.circle);
                setMaxGeofences(deviceModel?.deviceModelGeofence?.maxGeofence || 0);

            }
            setDeviceModelTitle(messages['create_device_model_edit_title']);
            setCurrentDM(deviceModel);
            setDmAlertTypes(deviceModel.deviceModelAlertTypes || [])
            dispatch(clearRedux("CREATE_EDIT_DEVICE_MODEL", { deviceModel: null }))
        }
    }, [create, update, deviceModel])

    useEffect(() => {
        openModal && dispatch(searchEntityRequest({ key: "alertTypes" }));
    }, [openModal]);

    useEffect(() => {
        if (result && !result.error) {
            setDmAlertTypes(result?.deviceModelAlertTypes)
        }
    }, [result])

    let manMaxPoint = 50;
    let manMaxGeofences = 50;
    if (manufacturer.name.toUpperCase() === "CalAmp".toUpperCase()) {
        manMaxGeofences = 50
        manMaxPoint = 20;
    } else if (manufacturer.name.toUpperCase() === "Geometris".toUpperCase()) {
        manMaxGeofences = 10
        manMaxPoint = 50;
    } else if (manufacturer.name.toUpperCase() === "Queclink".toUpperCase()) {
        manMaxGeofences = 20
        manMaxPoint = 10;
    }

    return (
        <>
            <Modal
                open={openModal}
                title={current ? `${messages['create_device_model_edit_title']} ${deviceModelTitle ? ` (${currentDM.name})` : ''}` : messages['create_device_model_create_title']}
                handleClose={() => closeModal()}
                position="right"
                loading={loading}
                size={editAlertTypeSupportedOpenModel ? "small" : "medium"}
            >
                <ModalBody>
                    <div style={{ padding: '0 10px', marginBottom: 50 }}>
                        <Form
                            ref={formRef}
                            onValidSubmit={() => applyChanges()}
                            onSubmit={() => {
                                if (!unitTypeId || !name || !product || !system || !network) {
                                    setTab(0)
                                    return false
                                } else if ((supportGeofences && !maxGeofences) || (polygon && !maxPoints)) {
                                    setTab(2)
                                    return false
                                }
                                return true
                            }}
                            noValidate
                        >
                            <Tabs tab={tab} onChange={(numberTab) => setTab(numberTab)} scrollButtons>
                                <TabContainer
                                    label={messages['create_device_model_tab_general']}
                                    index={0}
                                >
                                    <div style={{ padding: '5px 10px', marginTop: 5, marginBottom: 5 }}>
                                        <div style={{ marginTop: 5 }}>
                                            <Select
                                                id="unittypes-list"
                                                label={messages['create_device_model_unit_type']}
                                                placeholder={messages['create_device_model_unit_type']}
                                                options={unitTypes || []}
                                                onChange={(value) => setUnitTypeId(value?.id)}
                                                value={unitTypeId ? unitTypes.find(x => x.id === unitTypeId) : null}
                                                textField="name"
                                                valueField="id"
                                                isClearable
                                                required
                                                requiredMessage={messages["common_field_required"]}
                                            />
                                        </div>
                                        <div style={{ marginTop: 5 }}>
                                            <Input
                                                label={messages['create_device_model_name']}
                                                placeholder={messages['create_device_model_name']}
                                                value={name}
                                                onChange={(value) => setName(value)}
                                                required
                                                requiredMessage={messages["common_field_required"]}
                                                maxLength={25}
                                                title={""}
                                            />
                                        </div>
                                        <div style={{ marginTop: 5 }}>
                                            <Input
                                                label={messages['create_device_model_product']}
                                                placeholder={messages['create_device_model_product']}
                                                value={product}
                                                onChange={(value) => setProduct(value)}
                                                required
                                                requiredMessage={messages["common_field_required"]}
                                                maxLength={25}
                                            />
                                        </div>
                                        <div style={{ marginTop: 5 }}>
                                            <Select
                                                id="systems-list"
                                                label={messages['create_device_model_system']}
                                                placeholder={messages['create_device_model_system']}
                                                options={getSystems() || []}
                                                onChange={(value) => setSystem(value)}
                                                value={system}
                                                textField="name"
                                                valueField="id"
                                                isClearable
                                                required
                                                requiredMessage={messages["common_field_required"]}
                                            />
                                        </div>
                                        <div style={{ marginTop: 5 }}>
                                            <Select
                                                id="networks-list"
                                                label={messages['create_device_model_network']}
                                                placeholder={messages['create_device_model_network']}
                                                options={getNetworks() || []}
                                                onChange={(value) => setNetwork(value)}
                                                value={network}
                                                textField="name"
                                                valueField="id"
                                                isClearable
                                                required
                                                requiredMessage={messages["common_field_required"]}
                                            />
                                        </div>
                                        <div style={{ marginTop: 5 }}>
                                            <Input
                                                type="number"
                                                label={messages['create_device_model_inputs']}
                                                placeholder={messages['create_device_model_inputs']}
                                                value={inputs}
                                                onChange={(value) => setInputs(value)}
                                                max={13}
                                                min={0}
                                                requiredMessage={messages["common_field_required"]}
                                                maxMessage={`${messages["create_device_model_max_number"]} 12`}
                                                minMessage={`${messages["create_device_model_min_number"]} 0`}
                                                title={""}
                                            />
                                        </div>
                                        <div style={{ marginTop: 5 }}>
                                            <Input
                                                type="number"
                                                label={messages['create_device_model_ouputs']}
                                                placeholder={messages['create_device_model_ouputs']}
                                                value={outputs}
                                                onChange={(value) => setOutputs(value)}
                                                max={13}
                                                min={0}
                                                requiredMessage={messages["common_field_required"]}
                                                maxMessage={`${messages["create_device_model_max_number"]} 12`}
                                                minMessage={`${messages["create_device_model_min_number"]} 0`}
                                                title={""}
                                            />
                                        </div>
                                        <Grid container>
                                            <Grid xs={4} item>
                                                <div style={{ textAlign: 'left', display: 'grid', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_mark_initial_battery']}</label>
                                                    <ToggleSwitch
                                                        id="mark-initial-battery"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={markInitialBattery}
                                                        onChange={(checked) => {
                                                            setMarkInitialBattery(checked)
                                                            if (!checked)
                                                                setInitialBattery(0)
                                                        }}
                                                    />
                                                </div>
                                            </Grid>
                                            {
                                                markInitialBattery &&
                                                <Grid xs={8} item>
                                                    <div style={{ marginTop: 5 }}>
                                                        <Input
                                                            type="number"
                                                            label={messages['create_device_model_initial_battery']}
                                                            placeholder={messages['create_device_model_initial_battery']}
                                                            value={initialBattery}
                                                            onChange={(value) => setInitialBattery(value)}
                                                            disabled={!markInitialBattery}
                                                            max={100001}
                                                            min={0}
                                                            required
                                                            requiredMessage={messages["common_field_required"]}
                                                            maxMessage={`${messages["create_device_model_max_number"]} 100000`}
                                                            minMessage={`${messages["create_device_model_min_number"]} 0`}
                                                            title={""}
                                                        />
                                                    </div>
                                                </Grid>
                                            }
                                        </Grid>
                                    </div>
                                </TabContainer>
                                <TabContainer
                                    label={messages['create_device_model_tab_options']}
                                    index={1}
                                >
                                    <div style={{ padding: '5px 10px', marginTop: 5, marginBottom: 5 }}>
                                        <Grid container>
                                            <Grid xs={4} item>
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_ota']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-ota"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={ota}
                                                        onChange={(checked) => setOta(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item>
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_sms']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-sms"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={sms}
                                                        onChange={(checked) => setSms(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item>
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_starter']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-starter"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={starter}
                                                        onChange={(checked) => setStarter(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item>
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_driver_behavior']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-driver-behavior"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={driverBehavior}
                                                        onChange={(checked) => setDriverBehavior(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item>
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_analytic']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-analytic"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={analytic}
                                                        onChange={(checked) => setAnalytic(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item >
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_uses_sim']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-uses-sim"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={versionSim}
                                                        onChange={(checked) => setVersionSim(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item >
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_motion']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-motion"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={motion}
                                                        onChange={(checked) => setMotion(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item >
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_obd2_alerts']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-obd2-alerts"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={obd2alerts}
                                                        onChange={(checked) => setObd2alerts(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item >
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_hours_enable']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-hours-enable"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={hoursEnable}
                                                        onChange={(checked) => setHoursEnable(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item >
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_odometer_enable']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-odometer-enable"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={odometerEnable}
                                                        onChange={(checked) => setOdometerEnable(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item >
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_promiles']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-promiles"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={promiles}
                                                        onChange={(checked) => setPromiles(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item >
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_comdata']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-comdata"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={comdata}
                                                        onChange={(checked) => setComdata(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item >
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_pressure_pro']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-pressure-pro"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={pressurePro}
                                                        onChange={(checked) => setPressurePro(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item >
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_vbus']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-vbus"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={vBus}
                                                        onChange={(checked) => setVBus(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item >
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_jbus']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-jbus"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={jBus}
                                                        onChange={(checked) => setJBus(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item >
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_tow']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-tow"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={tow}
                                                        onChange={(checked) => setTow(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item >
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_ttu']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-ttu"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={ttu}
                                                        onChange={(checked) => setTtu(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item >
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">Car IQ</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-cariq"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={cariq}
                                                        onChange={(checked) => setCariq(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid xs={4} item >
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_carb']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-options-carbEnable"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={carbEnable}
                                                        onChange={(checked) => setCarbEnable(checked)}
                                                    />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </TabContainer>
                                <TabContainer
                                    label={messages['create_device_model_tab_Geofences']}
                                    index={2}
                                >
                                    <div style={{ padding: '5px 10px', marginTop: 5, marginBottom: 5 }}>
                                        <Grid container>
                                            <Grid xs={6} item >
                                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_support_geofences']}</label>
                                                    <ToggleSwitch
                                                        id="device-model-support-geofences"
                                                        medium
                                                        blueToggle
                                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                                        checked={supportGeofences}
                                                        onChange={(checked) => {
                                                            setSupportGeofences(checked)
                                                            if (!checked) {
                                                                setMaxPoints(0);
                                                                setMaxGeofences(0)
                                                                setPolygon(false);
                                                                setRegularShape(false);
                                                                setSquare(false);
                                                                setCircle(false);
                                                            }
                                                        }
                                                        }
                                                    />
                                                </div>
                                            </Grid>
                                            {
                                                supportGeofences &&
                                                <Grid xs={6} item >
                                                    <div style={{ marginTop: 5 }}>
                                                        <Input
                                                            type="number"
                                                            label={messages['create_device_model_max_geofences']}
                                                            placeholder={messages['create_device_model_max_geofences']}
                                                            value={maxGeofences}
                                                            onChange={(value) => setMaxGeofences(value)}
                                                            disabled={!supportGeofences}
                                                            max={manMaxGeofences + 1}
                                                            min={1}
                                                            requiredMessage={messages["common_field_required"]}
                                                            maxMessage={`${messages["create_device_model_max_number"]} ${manMaxGeofences}`}
                                                            minMessage={`${messages["create_device_model_min_number"]} 1`}
                                                            required
                                                            title=""
                                                        />
                                                    </div>
                                                </Grid>
                                            }
                                        </Grid>
                                        {
                                            supportGeofences &&
                                            <Grid container>
                                                <Grid xs={6} item >
                                                    <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                        <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_polygon']}</label>
                                                        <ToggleSwitch
                                                            id="device-model-options-polygon"
                                                            medium
                                                            blueToggle
                                                            optionLabels={[messages['common_yes'], messages['common_no']]}
                                                            checked={polygon}
                                                            onChange={(checked) => {
                                                                setPolygon(checked)
                                                                if (!checked)
                                                                    setMaxPoints(0);
                                                            }}
                                                            disabled={!supportGeofences}
                                                        />
                                                    </div>
                                                </Grid>
                                                {
                                                    polygon &&
                                                    <Grid xs={6} item>
                                                        <div style={{ marginTop: 5 }}>
                                                            <Input
                                                                type="number"
                                                                style={{ "-moz-appearance": "textfield" }}
                                                                label={messages['create_device_model_max_points']}
                                                                placeholder={messages['create_device_model_max_points']}
                                                                value={maxPoints}
                                                                onChange={(value) => setMaxPoints(value)}
                                                                disabled={!supportGeofences || !polygon}
                                                                max={manMaxPoint + 1}
                                                                min={3}
                                                                requiredMessage={messages["common_field_required"]}
                                                                maxMessage={`${messages["create_device_model_max_number"]} ${manMaxPoint}`}
                                                                minMessage={`${messages["create_device_model_min_number"]} 3`}
                                                                required
                                                                title=""
                                                            />
                                                        </div>
                                                    </Grid>
                                                }

                                                <Grid container>
                                                    <Grid xs={6} item >
                                                        <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                            <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_square']}</label>
                                                            <ToggleSwitch
                                                                id="device-model-options-square"
                                                                medium
                                                                blueToggle
                                                                optionLabels={[messages['common_yes'], messages['common_no']]}
                                                                checked={square}
                                                                onChange={(checked) => setSquare(checked)}
                                                                disabled={!supportGeofences}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    <Grid xs={6} item >
                                                        <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px', marginTop: 5 }}>
                                                            <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_device_model_circle']}</label>
                                                            <ToggleSwitch
                                                                id="device-model-options-circle"
                                                                medium
                                                                blueToggle
                                                                optionLabels={[messages['common_yes'], messages['common_no']]}
                                                                checked={circle}
                                                                onChange={(checked) => setCircle(checked)}
                                                                disabled={!supportGeofences}
                                                            />
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }
                                    </div>
                                </TabContainer>
                                {
                                    current &&
                                    <TabContainer
                                        label={messages['create_device_model_tab_alert_types']}
                                        index={3}
                                    >
                                        <div style={{ padding: '5px 10px', marginTop: 5, marginBottom: 5 }}>
                                            <Grid container>
                                                <AlertTypesSupported
                                                    alertTypes={alertTypes}
                                                    deviceModel={current}
                                                    dmAlertTypes={dmAlertTypes}
                                                />
                                            </Grid>
                                        </div>
                                    </TabContainer>
                                }
                            </Tabs>
                        </Form>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-cancel"
                        onClick={() => closeModal()}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        className="btn-dark-blue"
                        onClick={() => formRef?.current?.submit()}
                    >
                        {messages['save']}
                    </Button>
                </ModalFooter>
            </Modal>
            {editAlertTypeSupportedOpenModel && <EditAlertTypeSupported />}
        </>

    )
}

export default CreateEditDeviceModel;